// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__17iXG","col":"styles_col__Q5wfQ"};